export default function Machines_B_1 (number = 1) {
  return {
    name: '高速传送带',
    icon: '/static/img/machines/b1.png',
    number
  }
}



// WEBPACK FOOTER //
// ./src/components/Machines_B/Machines_B_1.js